import Section from "../../../components/Section";
import Avatar from "../../../components/Avatars";
import {
  AppStoreButton,
  AppStoreInfo,
  AppStoreType,
  Description,
  Game,
  Preview,
  Thumbnails,
} from "../../../components/GamePage";

import styles from "./index.module.scss";
import { GamesTsunamiJump } from "../../../constants/links";
import { ReactNode } from "react";
import { Helmet } from "react-helmet";

const Subtitle = "";

const Buttons = [
  <AppStoreButton
    className={styles.appStoreMobileButtons}
    href="https://apps.apple.com/us/app/tsunami-jump-endless-runner/id6751536475"
    appStore={AppStoreType.apple}
  />,
  <AppStoreButton
    className={styles.appStoreMobileButtons}
    href="https://play.google.com/store/apps/details?id=com.CozyLabs.TsunamiJump"
    appStore={AppStoreType.android}
  />,
];

export const TsunamiJumpPreview = ({}: {}) => {
  return (
    <Preview
      titleSrc={"/assets/images/games/tsunami_jump/logo_tsunami_jump.png"}
      cardSrc={"/assets/images/games/tsunami_jump/bg.png"}
      subtitle={Subtitle}
      href={GamesTsunamiJump}
    />
  );
};

const TsunamiJumpGame = ({ buttons }: { buttons: ReactNode[] }) => {
  const unityConfig = {
    loaderUrl: "/assets/build/tsunami_jump/WebGL.loader.js",
    dataUrl: "/assets/build/tsunami_jump/WebGL.data",
    frameworkUrl: "/assets/build/tsunami_jump/WebGL.framework.js",
    codeUrl: "/assets/build/tsunami_jump/WebGL.wasm",
  };

  return (
    <Game
      unityConfig={unityConfig}
      titleSrc={"/assets/images/games/tsunami_jump/logo_tsunami_jump.png"}
      subtitle={Subtitle}
      buttons={buttons}
    />
  );
};

const TsunamiJumpHero = ({
  children,
  playable = true,
}: {
  children?;
  playable?: boolean;
}) => {
  return (
    <Section className={styles.hero}>
      <Helmet>
        <title>Cozyverse | Play Tsunami Jump</title>
        <meta name="apple-itunes-app" content="app-id=6450430184" />
      </Helmet>
      {playable ? (
        <TsunamiJumpGame buttons={Buttons} />
      ) : (
        <TsunamiJumpPreview />
      )}
      {children}
      <Avatar
        img="/assets/images/games/tsunami_jump/ground.png"
        hideMobile
        style={{
          bottom: "-0.5rem",
          width: "101%",
        }}
      />
      <Avatar
        img="/assets/images/games/tsunami_jump/cozy.png"
        hideMobile
        style={{
          bottom: "1rem",
          left: "2rem",
          maxWidth: "22%",
        }}
      />
      <Avatar
        img="/assets/images/games/tsunami_jump/duck.png"
        hideMobile
        style={{
          bottom: "15rem",
          right: "5%",
          maxWidth: "10%",
        }}
      />
    </Section>
  );
};

const TsunamiJumpPage = () => {
  return (
    <div className={styles.root}>
      <TsunamiJumpHero playable={true} />
      <Section className={styles.about}>
        <AppStoreInfo
          iconImg="/assets/images/games/tsunami_jump/icon_tsunami_jump.png"
          buttons={[
            <AppStoreButton
              className={styles.appStoreDesktopButtons}
              href="https://apps.apple.com/us/app/tsunami-jump-endless-runner/id6751536475"
              appStore={AppStoreType.apple}
            />,
            <AppStoreButton
              className={styles.appStoreDesktopButtons}
              href="https://play.google.com/store/apps/details?id=com.CozyLabs.TsunamiJump"
              appStore={AppStoreType.android}
            />,
          ]}
        />
        <Description>
          <p>
            Tsunami Jump is a fast-paced hyper-casual game where survival means
            leaping forward before the tsunami catches you. Platforms are your
            only chance to escape—time your jumps, stay ahead, and don’t let the
            wave take you down!
          </p>
          <h3>How to Play</h3>
          <p>- Jump from platform to platform</p>
          <p>
            - If you fall in the water or hit an obstacle, reset to the last
            platform
          </p>
          <p>- If you get hit by the Tsunami, the game ends</p>
          <p>
            {" "}
            *Mobile browser not supported. Download the app on Apple App Store
            and Google Play.
          </p>
        </Description>
        {/* <Thumbnails>
          <img src="/assets/images/games/land_slide/1.png" />
          <img src="/assets/images/games/land_slide/2.png" />
          <img src="/assets/images/games/land_slide/3.png" />
          <img src="/assets/images/games/land_slide/4.png" />
        </Thumbnails> */}
        <Avatar
          img="/assets/images/games/shared/ducks.png"
          hideMobile
          style={{
            left: "-15rem",
            bottom: "-10rem",
          }}
        />
        <Avatar
          img="/assets/images/games/shared/ducks.png"
          hideMobile
          style={{
            right: "-15rem",
            top: "-10rem",
          }}
        />
      </Section>
    </div>
  );
};

export { TsunamiJumpPage, TsunamiJumpHero };
